import { apiGet, apiPatch } from './client';
import type {
  ISAAssetType,
  ISAAssetTypeBatchRequest,
} from '../types/ISAAssetType';

export function getISAAssetTypes(): Promise<ISAAssetType[]> {
  return apiGet<ISAAssetType[]>('/api/isa-asset-types');
}

export function saveBatchISAAssetTypes(
  added: ISAAssetType[],
  modified: ISAAssetType[],
  deletedIds: number[],
): Promise<ISAAssetType[]> {
  return apiPatch<ISAAssetTypeBatchRequest, ISAAssetType[]>(
    '/api/isa-asset-types/batch',
    { added, modified, deleted: deletedIds },
  );
}
